import React, {Component} from 'react'
import BookingEventSection from "./bookingevent.component.jsx";

class BookingSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            section: this.props.section || null,
            variables: this.props.variables || null,
            isPdf: this.props.isPdf || false,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.variables || null,
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }

        const bookingItems = this.state.variables.quote.items.filter(i => i.needsBooking)
        return <div className="row">
            <div className="col-12 text-center">
                {bookingItems.map((i, key) => {
                    return <BookingEventSection
                        key={i.id}
                        product={i.product}
                        productId={i.product.id}
                        itemId={i.id}
                        variables={this.state.variables}
                        section={this.state.section}
                        isPdf={this.state.isPdf}
                        isLast={key === (bookingItems.length-1)}
                    />
                })}
            </div>
        </div>
    }

}

export default BookingSection





// WEBPACK FOOTER //
// ./src/template/sections/content/approve-section/booking.component.jsx